/* ==========================================================================
   SCUFFERS 1:1 CHROME JS — drawer tabs + accordions, escape-close, newsletter
   (builder B6). Drawer open/close itself is handled by shared theme.js via
   [data-menu-toggle] / [data-nav-close] toggling .sc-drawer--open on
   #nav-drawer — this file only adds the chrome-specific behaviors.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var drawer = document.getElementById('nav-drawer');

    /* ---------- Drawer tabs (Man / Woman / Footwear) ---------- */
    if (drawer) {
      var triggers = drawer.querySelectorAll('[data-drawer-tab]');
      var panels = drawer.querySelectorAll('[data-drawer-panel]');
      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-drawer-tab');
          triggers.forEach(function (t) { t.classList.toggle('active', t === btn); });
          panels.forEach(function (p) {
            p.classList.toggle('active', p.getAttribute('data-drawer-panel') === idx);
          });
        });
      });

      /* ---------- Accordion groups (Shop Tops +, ...) ---------- */
      drawer.querySelectorAll('[data-drawer-accordion]').forEach(function (toggle) {
        function flip() {
          var li = toggle.parentElement;
          if (li) li.classList.toggle('open');
        }
        toggle.addEventListener('click', flip);
        toggle.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); }
        });
      });

      /* ---------- Escape closes the drawer ---------- */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('sc-drawer--open')) {
          drawer.classList.remove('sc-drawer--open');
          document.body.classList.remove('no-scroll');
        }
      });
    }

    /* ---------- Footer newsletter: focus ring + posted state scroll ---------- */
    var newsletterForm = document.getElementById('footer-newsletter');
    if (newsletterForm) {
      // Shopify reloads with #footer-newsletter + customer_posted=true on success;
      // liquid already swaps the form for the success message. Just make sure
      // the confirmation is visible.
      if (/customer_posted=true/.test(window.location.search)) {
        var msg = newsletterForm.querySelector('.schrome-newsletter-msg--success');
        if (msg) msg.scrollIntoView({ block: 'center' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* drawer shop-group expanders (Scuffers anatomy, 2026-07-04) */
(function () {
  function init() {
    document.querySelectorAll('[data-group-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('.schrome-menu-group');
        var open = li.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
